// exclude-from-index
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import MuiSelect from '@mui/material/Select';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { muiGlobalTheme } from '@themes';
import { colors } from '../../css';

class Select extends PureComponent {
  constructor(props) {
    super(props);
    const { autoWidth } = props;

    this.muiTheme = muiGlobalTheme;

    if (!autoWidth) {
      muiGlobalTheme.components.MuiFormControl = {
        styleOverrides: { root: { width: '100%', minWidth: '120px' } }
      };
    }

    muiGlobalTheme.palette.text.secondary = colors.colorGrey03;
    this.selectTheme = createTheme(this.muiTheme);
  }

  render() {
    const { errorText, helperText, autoWidth, ...defaults } = this.props;
    const { disabled, id, error, label, name, options, required, value } = defaults;

    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={this.selectTheme}>
          <FormControl disabled={disabled} error={error}>
            <InputLabel shrink id="select-placeholder-label-label">
              {label}
            </InputLabel>
            <MuiSelect
              id="select-placeholder-label"
              displayEmpty
              value={value}
              inputProps={{ name, id }}
              required={required}
              {...defaults}
            >
              {options.map((option) => (
                <MenuItem disabled={option.isDisabled} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </MuiSelect>
            {((error && errorText) || helperText) && (
              <FormHelperText>{(error && errorText) || helperText}</FormHelperText>
            )}
          </FormControl>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

Select.propTypes = {
  /**
   * Displays additonal text (or replaces helper text) that sits below the select
   */
  errorText: PropTypes.string,
  /**
   * Displays additonal text that sits below the select
   */
  helperText: PropTypes.string,
  /**
   * Provides a unique identifier used between the lable and select
   */
  id: PropTypes.string.isRequired,
  /**
   * Displays text over the select and acts as a label for the select
   */
  label: PropTypes.string.isRequired,
  /**
   * Select name value
   */
  name: PropTypes.string.isRequired,
  /**
   * isDisabled: disables the use of the option and updates the styles
   * label: Option text displayed in the select dropdown
   * value: Value to return when selected
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      isDisabled: PropTypes.bool,
      label: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
        PropTypes.object.isRequired
      ]),
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * Sets Select width to content width
   */
  autoWidth: PropTypes.bool
};

Select.defaultProps = {
  errorText: undefined,
  helperText: undefined,
  autoWidth: undefined
};

export default Select;
